export const OPTIMIZER_POLL_INTERVAL_MS = 5_000;
export const REPORTS_PAGE_SIZE = 25;
export const AUTO_FULL_FETCH_LIMIT = 50;
export const FILTER_FULL_FETCH_MAX = 500;
/** Empty STR/BTR lists poll this long for late writes, then stop. */
export const REVIEW_EMPTY_STR_POLL_WINDOW_MS = OPTIMIZER_POLL_INTERVAL_MS * 6;
export const REVIEW_EMPTY_BTR_POLL_WINDOW_MS = REVIEW_EMPTY_STR_POLL_WINDOW_MS;

export const resolveReviewTradeSettleConfirmMs = (): number =>
  process.env.VITEST ? 0 : OPTIMIZER_POLL_INTERVAL_MS;

/** Refresh hold/settlement presentation while the review step stays open. */
export const REVIEW_TRADE_HOLD_CLOCK_MS = 60_000;
